import React from "react";
import { motion } from "framer-motion";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import { HiStar } from "react-icons/hi2";
const Products = ({ title, products }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const ButtonGroup = ({ next, previous }) => {
    return (
      <div className="flex justify-between items-center">
        <button
          onClick={() => previous()}
          className="w-[30px] rounded-full h-[30px] flex justify-center items-center bg-slate-300 hover:bg-[#212730] hover:text-slate-200 hover:border-indigo-300 border border-slate-200"
        >
          <span>
            <FiChevronLeft />
          </span>
        </button>
        <div className="text-xl font-bold text-[#212730]">{title}</div>
        <div className="flex justify-center items-center gap-3 text-slate-600  ">
          <button
            onClick={() => next()}
            className="w-[30px] rounded-full h-[30px] flex justify-center items-center bg-slate-300 hover:bg-[#212730] hover:text-slate-200 hover:border-indigo-300 border border-slate-200"
          >
            <span>
              <FiChevronRight />
            </span>
          </button>
        </div>
      </div>
    );
  };
  return (
    <div className="flex gap-7 w-[97%] md:w-[100%] flex-col-reverse">
      <Carousel
        autoPlay={false}
        infinite={false}
        arrows={false}
        responsive={responsive}
        transitionDuration={500}
        renderButtonGroupOutside={true}
        customButtonGroup={<ButtonGroup />}
        className="rounded-[10px]"
      >
        {products.map((p, i) => {
          return (
            <div key={i} className="flex flex-col w-[96%] justify-start gap-4 ">
              {p.map((pl, j) => (
                <motion.div
                  className="w-full h-full rounded-[20px] hover:rounded-[20px] hover:bg-white hover:drop-shadow-md"
                  whileHover={{ x: 2 }}
                  whileTap={{ scale: 0.97 }}
                >
                  <Link
                    key={j}
                    className="flex gap-1 justify-start items-start"
                    to={`/product/details/${pl.slug}`}
                  >
                    <img
                      className="w-[110px] rounded-[10px] h-[110px]"
                      src={pl.images[0]}
                      alt="images"
                    />
                    <div className="p-3 flex justify-start items-start gap-1.5 flex-col text-slate-600 ">
                      <h2>{pl.name}</h2>
                      <span className="text-sm flex items-center">
                        <HiStar className="mr-1 text-[#EDBB0E]" /> {pl.rating}/5{" "}
                      </span>
                      <span className="text-lg font-bold">
                        Rs.
                        {pl.discount
                          ? pl.price -
                            Math.floor((pl.price * pl.discount) / 100)
                          : pl.price}
                      </span>
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default Products;
